import React from 'react';
import { Button } from '../Button/ButtonElements';
import CardItem from './CardItem';
import './Cards2.css';
import LndRvr from '../../images/LandRover.PNG';
import CardItem2 from './CardItem2';
import styled from 'styled-components';
import Img3 from '../../SoldJag/sold-jag.jpg';
import { useEffect } from 'react';
import ImgWMerc from '../../wmerc/wmerc1.jpg';
import ImgBMW from '../../bmw/bmw1.jpg';
import ImgMit from '../../mit/mit1.jpg';
import ImgBni from '../../bni/bni1.jpg';
import ImgPco from '../../pco/pco1.jpg';
import ImgGolf from '../../golf/golf1.jpg';
import Aos from 'aos';
import 'aos/dist/aos.css';
import { useState } from 'react';
import {collection, getDocs} from "firebase/firestore";
import {db} from "../../firebase.config";
import {ClipLoader} from "react-spinners";

const H1 = styled.h1`
  font-family: 'Poppins';
  font-weight: 400;
  color: rgb(80, 80, 80);
  font-size: 1.5rem;
  margin-top: 25px;
  @media screen and (max-width: 768px) {
    padding: 20px;
  }
`;
const CardsWrapper = styled.div`
  margin-top: -20px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: 20px;
  @media screen and (max-width: 1425px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
  @media screen and (max-width: 1200px) {
    grid-template-columns: 1fr 1fr;
  }
  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;
const Search = styled.div`
  display: flex;
  justify-content: center;
  display: grid;
`;
const SearchH = styled.span`
  font-family: 'Poppins';
  padding: 10px;
`;
const SearchWrap = styled.div`
  padding: 20px;

  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  background: rgb(237, 237, 237);
  grid-gap: -50px;
  @media screen and (max-width: 1000px) {
    grid-template-columns: 1fr;
    display: none;
  }
`;
const SearchWrap2 = styled.div`
  padding: 20px;

  display: grid;
  display: none;
  grid-template-columns: 1fr 1fr 1fr;
  background: rgb(237, 237, 237);
  grid-gap: -50px;
  @media screen and (max-width: 1000px) {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
`;
const Select = styled.select`
  width: 200px;
  height: 50px;
  padding-right: 25px;
  //padding-left: 25px;
`;
const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 20px;
  grid-gap: 300px;
  @media screen and (max-width: 800px) {
    grid-gap: 20px;
  }
  @media screen and (max-width: 550px) {
    grid-template-columns: 1fr;
  }
`;
function Cards() {
  const SearchIcon = <i class="fa-solid fa-magnifying-glass"></i>;
  const [searchTerm, setSearchTerm] = useState('');
  const [carData, setCarData] = useState([]);
  const carsCollection = collection(db, 'cars');
  
  useEffect(() => {
    Aos.init({ duration: 500 });
  }, []);

  const [sortOrder, setSortOrder] = useState('');

  const handleSortChange = (event) => {
    const selectedOrder = event.target.value;
    setSortOrder(selectedOrder);
    sortItems(selectedOrder);
  };

  const sortItems = (order) => {
    const sortedCars = [...carData];

    if (order === 'highToLow') {
      sortedCars.sort((a, b) => b.price - a.price);
    } else if (order === 'lowToHigh') {
      sortedCars.sort((a, b) => a.price - b.price);
    }
    if (order === 'MilesHighToLow') {
      sortedCars.sort((a, b) => b.miles - a.miles);
    } else if (order === 'MilesLowToHigh') {
      sortedCars.sort((a, b) => a.miles - b.miles);
    }
    setCarData(sortedCars);
  };

  const fetchCarDetails = async () => {
    try {
      const carDocs = await getDocs(carsCollection);
      return carDocs.docs.map(car => ({
        id: car.id,
        ...car.data()
      }));
    } catch (err) {
      console.error("Error getting car document", err);
    }
  }

  const buildCarData = async () => {
    const results = await fetchCarDetails();
    return Promise.all((results ?? []).map(async (car) => {
      const imagesRef = collection(db, `cars/${car.id}/images`);
      const imageDocs = await getDocs(imagesRef);
      const images = imageDocs.docs.map(doc => ({
        docId: doc.id,
        ...doc.data()
      }));

      const sortedImages = images.slice().sort((a, b) => a.id - b.id);
      return { ...car, images: sortedImages };
    }));
  }
  
  useEffect(() => {
    async function getCarData() {
      const carWithImages = await buildCarData();
      const sortedCarWithImages = carWithImages.slice().sort((a,b) => a.order - b.order);
      setCarData(sortedCarWithImages);
    }
    
    void getCarData();
  }, []);
  
  return (
    <div className="cards" data-aos="fade-up">
      <SearchWrap>
        <Search>
          <SearchH>Search our cars:</SearchH>
          <div>
            <input
              className="search-engine"
              type="text"
              placeholder="Search.."
              onChange={(event) => {
                setSearchTerm(event.target.value);
              }}
            />
          </div>
        </Search>

        <H1>Latest Stock</H1>
        <div className="select-container">
          <select
            className="select-box"
            onChange={handleSortChange}
            value={sortOrder}
          >
            <option value="" disabled hidden>
              Sort
            </option>
            <option className="option1" value="highToLow">
              Price (High to Low)
            </option>

            <option value="lowToHigh">Price (Low to High)</option>
            <option value="MilesLowToHigh">Mileage (Low to High)</option>
          </select>
        </div>
        {/* <button onClick={sortByPriceHighToLow}>Price (High to Low)</button> */}
      </SearchWrap>
      <SearchWrap2>
        <H1>Latest Stock</H1>
        <Grid>
          <Search>
            <SearchH>Search our cars:</SearchH>
            <div>
              <input
                className="search-engine"
                type="text"
                placeholder="Search.."
                onChange={(event) => {
                  setSearchTerm(event.target.value);
                }}
              />
            </div>
          </Search>

          <div className="select-container">
            <select
              className="select-box"
              onChange={handleSortChange}
              value={sortOrder}
            >
              <option value="" disabled hidden>
                Sort
              </option>
              <option className="option1" value="highToLow">
                Price (High to Low)
              </option>

              <option value="lowToHigh">Price (Low to High)</option>
              <option value="MilesLowToHigh">Mileage (Low to High)</option>
            </select>
          </div>
        </Grid>
      </SearchWrap2>
      <div className="cards__container">
        <div className="cards__wrapper">
          {carData.length === 0 ? (
              <ClipLoader size={30} color={'#000'} loading={true} />
          ): (
              <CardsWrapper>
                {carData
                    .filter((car) => {
                      if (searchTerm === '') {
                        return car;
                      } else if (
                          car?.title?.toLowerCase().includes(searchTerm?.toLowerCase()) || car?.spec?.toLowerCase().includes(searchTerm?.toLowerCase())
                      ) {
                        return car;
                      }
                    })
                    .map((car, key) => {
                      return (
                          <CardItem2
                              text={car.title}
                              src={car.images[0]?.url}
                              label={car.label}
                              path={car.sold ? '/sold' : `/latest-stock/${car.id}`}
                              text2={car.spec}
                              price={car.price}
                              miles={car.miles}
                          />
                      );
                    })}
              </CardsWrapper>
          )}
        </div>
      </div>
    </div>
  );
}

export default Cards;
